module.exports = __webpack_public_path__ + "static/img/salesman.398c4cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesman.png
// module id = F4oA
// module chunks = 2